import React from "react";
import useElements from "../hooks/useElements";
const Logo = props => {
  const {
    value,
    pages,
    className,
    noLink = false
  } = props;
  const {
    base
  } = useElements();
  const Image = base?.Image;
  const PageLink = base?.PageLink;
  const imageUrl = typeof value === "string" ? value : value.url;
  const logoSize = value.size === "small" ? 30 : value.size === "large" ? 80 : 50;
  if (noLink) {
    return /*#__PURE__*/React.createElement(Image, {
      className: className,
      style: {
        maxWidth: "100%",
        maxHeight: logoSize
      },
      src: imageUrl || {}
    });
  }
  const homePage = pages?.find?.(page => page.home_page);
  return /*#__PURE__*/React.createElement(PageLink, {
    page: homePage
  }, /*#__PURE__*/React.createElement(Image, {
    className: className,
    style: {
      maxWidth: "100%",
      maxHeight: logoSize
    },
    src: imageUrl
  }));
};
export default Logo;
//# sourceMappingURL=Logo.js.map